module.exports = __webpack_public_path__ + "media/images/app_logo/512-79667079347cafd268bf09ee47edc043.png";